import { Link } from "react-router-dom";

const entries = [
  {
    to: "/category/movie",
    icon: "ri-film-line",
    title: "电影",
    desc: "从悬疑到科幻，覆盖院线与经典影片的完整剧情与演员资料",
    stat: "13 部作品",
  },
  {
    to: "/category/tv",
    icon: "ri-tv-2-line",
    title: "电视剧",
    desc: "都市、古装、罪案全类型剧集，追踪更新进度与演职员信息",
    stat: "11 部剧集",
  },
];

export default function CategoryEntry() {
  return (
    <section className="mx-auto w-full px-4 py-12 md:px-8 md:py-16">
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
        {entries.map((entry) => (
          <Link
            key={entry.to}
            to={entry.to}
            className="group relative flex items-center gap-5 overflow-hidden rounded-lg border border-background-200 bg-background-100 p-6 transition-colors hover:border-primary-300 md:p-8"
          >
            <span className="flex h-16 w-16 shrink-0 items-center justify-center rounded-lg bg-primary-700 text-background-50 transition-colors group-hover:bg-accent-500 group-hover:text-primary-950 md:h-20 md:w-20">
              <i className={`${entry.icon} text-3xl md:text-4xl`} />
            </span>
            <div className="min-w-0">
              <div className="flex items-center gap-2">
                <h3 className="font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">
                  {entry.title}
                </h3>
                <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-[11px] font-semibold text-secondary-900">
                  {entry.stat}
                </span>
              </div>
              <p className="mt-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
                {entry.desc}
              </p>
            </div>
            <i className="ri-arrow-right-up-line ml-auto hidden text-2xl text-foreground-400 transition-colors group-hover:text-accent-500 md:block" />
          </Link>
        ))}
      </div>
    </section>
  );
}